/*
 * @Description: 服务管理
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2021-07-03 11:41:05
 * @LastEditTime: 2023-05-17 16:32:33
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */

import { get, post } from '../index'
export default {
  // 服务分类列表
  cateList (querys) {
    return get('massage/admin/AdminService/cateList', querys)
  },
  // 服务分类下拉列表
  cateSelect (querys) {
    return get('massage/admin/AdminService/cateSelect', querys)
  },
  // 服务分类详情
  cateInfo (querys) {
    return get('massage/admin/AdminService/cateInfo', querys)
  },
  // 新增服务分类
  cateAdd (querys) {
    return post('massage/admin/AdminService/cateAdd', querys)
  },
  // 编辑服务分类
  cateUpdate (querys) {
    return post('massage/admin/AdminService/cateUpdate', querys)
  },
  // 审核服务
  checkStoreGoods (querys) {
    return post('massage/admin/AdminService/checkStoreGoods', querys)
  },
  // 服务列表
  serviceList (querys) {
    return get('massage/admin/AdminService/serviceList', querys)
  },
  // 服务详情
  serviceInfo (querys) {
    return get('massage/admin/AdminService/serviceInfo', querys)
  },
  // 新增服务
  serviceAdd (querys) {
    return post('massage/admin/AdminService/serviceAdd', querys)
  },
  // 编辑服务
  serviceUpdate (querys) {
    return post('massage/admin/AdminService/serviceUpdate', querys)
  },
  // 轮播图列表
  bannerList (querys) {
    return post('massage/admin/AdminSetting/bannerList', querys)
  },
  // 轮播图信息
  bannerInfo (querys) {
    return get('massage/admin/AdminSetting/bannerInfo', querys)
  },
  // 新增轮播图
  bannerAdd (querys) {
    return post('massage/admin/AdminSetting/bannerAdd', querys)
  },
  // 编辑轮播图
  bannerUpdate (querys) {
    return post('massage/admin/AdminSetting/bannerUpdate', querys)
  },
  // 加钟设置详情
  addClockInfo (querys) {
    return get('massage/admin/AdminSetting/addClockInfo', querys)
  },
  // 加钟设置
  addClockUpdate (querys) {
    return post('massage/admin/AdminSetting/addClockUpdate', querys)
  }

}



// WEBPACK FOOTER //
// ./src/api/modules/service.js